













































































import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class extends Vue {
    @Prop() value!: any

    @Prop({ default: new Date().setHours(0, 0, 0, 0) }) defaultTime!: any

    @Prop({ default: 5 }) stepCount!: any //分钟跨度

    @Prop({ default: false }) disabled!: any 

    @Prop({ default: true }) popperAppendToBody!: any

    @Prop({ default: true }) clearable!: any 

    @Prop({ default: '' }) placeholder!: any

    $refs: any

    showPanel: any = false

    timer: any = null //计时器

    hoursActiveIndex: any = 0

    minutesActiveIndex: any = 0

    isFocus: any = false

    hoursMenuEl: any = null

    minutesMenuEl: any = null

    oldVal: any = null

    showCloseIcon: any = false

    readonly: boolean = true

    mounted() {
        const parent = this.$parent.$parent.$el
        if (parent) {
            const tbody = parent.querySelector('.el-table__body-wrapper')
            if (tbody) {
                tbody.addEventListener('scroll', e => {
                    if (this.showPanel) {
                        this.calcPopperPosition()
                    }
                })
            }
        }
        document.addEventListener('mouseup', this.hidePanel)
    }

    beforeDestroy() {
        document.removeEventListener('mouseup', this.hidePanel)
    }
 
    get isEmpty() {
        return !this.value
    }

    get displayValue() {
        const val = this.value
        if (val) {
            const date = new Date(val)
            let hours: any = date.getHours()
            let minutes: any = date.getMinutes()

            hours = hours > 9 ? hours : '0' + hours
            minutes = minutes > 9 ? minutes : '0' + minutes

            return hours + ':' + minutes
        }
        return ''
    }

    get getMinutesList() {
        const res: any = []
        for (let i = 0; i < 60; i ++ ) {
            if (this.stepCount ) {
                if (i % this.stepCount === 0) res.push(i)
            } else {
                res.push(i)
            }
        }
        return res
    }

    get getHoursList() {
        const res: any = []
        for (let i = 0; i < 24; i ++ ) {
            res.push(i)
        }
        return res
    }
    
    // 计算弹出层位置
    calcPopperPosition(){
        const rect = this.$refs.zmTimePickRef.getBoundingClientRect()
        const scrollTop = document.documentElement.scrollTop
        const top = scrollTop + rect.top
        const left = rect.left

        if (rect.top + this.$refs.panelRef.clientHeight > window.innerHeight) {
            this.$refs.panelRef.style.top = top - this.$refs.panelRef.clientHeight - 10 + 'px'
            this.$refs.panelRef.style.left = left + 'px'
        } else {
            this.$refs.panelRef.style.top = top + 'px'
            this.$refs.panelRef.style.left = left + 'px'
            const height = this.$refs.inputRef.clientHeight
            this.$refs.panelRef.style.transform = `translate(0, ${height + 10}px)`
        }
    }

    updatePosition() {
        if (!this.showPanel) return


        if (this.popperAppendToBody) {
            document.body.appendChild(this.$refs.panelRef)
            this.calcPopperPosition()
        }

        const hoursMenuEl = this.$refs.housListRef
        const minutesMenuEl = this.$refs.minutesListRef

        const value = this.value || this.defaultTime

        const date = new Date(value)

        const h = date.getHours()
        const m = date.getMinutes()

        this.hoursActiveIndex = this.getHoursList.indexOf(h)
        this.minutesActiveIndex = this.getMinutesList.indexOf(m)

        hoursMenuEl.scrollTo({
            top: this.hoursActiveIndex * 32,
        })

        minutesMenuEl.scrollTo({
            top: this.minutesActiveIndex * 32,
        })
    }

    hidePanel(e) {
        var e = e || window.event;
        var target = e.target || e.srcElement;

        if (this.isFocus) return
            
        var panel = this.$refs.panelRef   //获取你的目标元素
    
        if (panel) {
            if(target !== panel && !panel.contains(target)) {    // 目标元素外
                this.showPanel = false
                this.isFocus = false
                if (this.oldVal) {
                    const oldVal = new Date(this.oldVal).setMilliseconds(0)
                    this.$emit('input', oldVal)
                }
            }
        }
    }

    panelClick(e) {
        e.stopPropagation()
        this.$refs.inputRef.focus()
    }

    handleFoucs() {
        this.showPanel = !this.showPanel
        this.isFocus = true

        if (!this.value) {
            this.$emit('input', this.defaultTime)
            this.$emit('focus', this.defaultTime)
        }

        this.oldVal = this.value || this.defaultTime

        this.$nextTick(() => {
            this.updatePosition()
        })
    }

    handleBlur(e) {
        this.isFocus = false
    }

    handleSelect(e) {
        const value = e.target.value
        if (this.displayValue === value) { // 判断全选
            this.readonly = false
        }
    }

    handlePaste(e) {
        const copiedText = e.clipboardData.getData('text');
        // hh:mm 格式校验
        const timeReg = /^(?:[01]\d|2[0-3]):[0-5]\d$/;
        if (timeReg.test(copiedText)) {
            console.log('value: ', copiedText);

            const hh = copiedText.split(':')[0]
            const mm = copiedText.split(':')[1]

            this.$emit('input', new Date().setHours(hh, mm))
            this.$emit('change', new Date().setHours(hh, mm))

            this.showPanel = false
            this.isFocus = false
        }
        this.readonly = true
    }

    hanleMouseenter() {
        if (!this.isEmpty) {
            this.showCloseIcon = true
        }
    }

    hanldeCloseIconClick() {
        this.showCloseIcon = false
        this.$emit('input', '')
        this.$emit('change', '')
    }

    choseHour(index, e) {
        const parent = e.target.parentElement
        parent.scrollTo({
            top: index * 32,
            behavior: 'smooth'
        })
        const h = this.getHoursList[index]
        const date = new Date(this.value)

        date.setHours(h)
        date.setMilliseconds(0)
        this.$emit('input', date)
    }

    choseMinute(index, e) {
        const parent = e.target.parentElement
        parent.scrollTo({
            top: index * 32,
            behavior: 'smooth'
        })
        const m = this.getMinutesList[index]
        const date = new Date(this.value)

        date.setMinutes(m)
        date.setMilliseconds(0)
        this.$emit('input', date)
    }

    bindScroll(e, type) {
        const el = e.target
        const scrollTop = el.scrollTop;
        const index = Math.round(scrollTop / 32)

        if (this.timer) {
            clearTimeout(this.timer)
        }

        this.timer = setTimeout(() => {
            el.scrollTo({
                top: index * 32,
                behavior: 'smooth'
            })

            if (type === 'hours') {
                this.hoursActiveIndex = index

                const h = this.getHoursList[index]
                const date = new Date(this.value)
                date.setHours(h)
                date.setMilliseconds(0)
                this.$emit('input', date)
            }

            if (type === 'minutes') {
                this.minutesActiveIndex = index

                const m = this.getMinutesList[index]
                const date = new Date(this.value)
                date.setMinutes(m)
                date.setMilliseconds(0)
                this.$emit('input', date)
            }
        }, 200)
    }

    cancelBtnClick() {
        this.showPanel = false
        this.isFocus = false
        
        const oldVal = new Date(this.oldVal).setMilliseconds(0)
        this.$emit('input', oldVal)
    }

    handleConfirm() {
        this.showPanel = false
        this.isFocus = false

        const date = new Date(this.value).setMilliseconds(0)
        this.$emit('input', date)
        this.$emit('change', date)
    }
}
